import { Injectable, OnDestroy } from '@angular/core';
import { Observable, BehaviorSubject, of, Subscription, Subject } from 'rxjs';
import { map, catchError, switchMap, finalize,  } from 'rxjs/operators';
import { Company, UserModel,User } from '../_models/user.model';
import { AuthModel, TokenRequest } from '../_models/auth.model';
import { AuthHTTPService } from './auth-http';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { ActionResult } from '../_models/action-result';
import { resetpassword } from '../_models/resetpassword';
import { ConfigService } from 'src/app/services/config.service';
import { Client } from '@microsoft/microsoft-graph-client';
import { AccountInfo,   InteractionType,PublicClientApplication, Configuration } from '@azure/msal-browser';
import { OauthService } from 'src/app/services/ouath.service';
import { AuthCodeMSALBrowserAuthenticationProvider } from '@microsoft/microsoft-graph-client/authProviders/authCodeMsalBrowser';
import * as MicrosoftGraph from '@microsoft/microsoft-graph-types';
import { MessagesService } from 'src/app/services/service.index';
import { MicroApplication } from 'src/app/services/microapplications/_models/microapplication.model';
import { HttpClient } from '@angular/common/http';


@Injectable({
	providedIn: 'root',
})
export class AuthService implements OnDestroy {
	acon: AccountInfo[];
	secret: string;
	qrCodeUri: string;
  handleRedirectCallback(arg0: (authError: any, response: any) => void) {
    throw new Error('Method not implemented.');
  }
	// private fields
	private unsubscribe: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
	private authLocalStorageToken = `${environment.appVersion}-${environment.USERDATA_KEY}`;


	public authenticated: boolean;
	public user?: User;
	public graphClient?: Client;
	private readonly _destroying$ = new Subject<void>()
	// public fields
	loggedIn = false;
	currentUser$: Observable<UserModel>;
	isLoading$: Observable<boolean>;
	azureAdConfig:any
	private msalInstance: PublicClientApplication;
	currentUserSubject: BehaviorSubject<UserModel>;
	isLoadingSubject: BehaviorSubject<boolean>;
	CompanieList: BehaviorSubject<Company[]> = new BehaviorSubject<Company[]>(
		[]
	);

	get currentUserValue(): UserModel {
		return this.currentUserSubject.value;
	}

	set currentUserValue(user: UserModel) {
		this.currentUserSubject.next(user);
	}


	
	constructor(
		private authHttpService: AuthHTTPService,
		private router: Router,
		private messagesService: MessagesService,
		private http: HttpClient,
		private configService: ConfigService,
		private OauthService: OauthService,
	) {
		this.isLoadingSubject = new BehaviorSubject<boolean>(false);
		 this.currentUserSubject = new BehaviorSubject<UserModel>(undefined);
		this.currentUser$ = this.currentUserSubject.asObservable();
		this.isLoading$ = this.isLoadingSubject.asObservable();
		const subscr = this.getUserByToken().subscribe();
		this.unsubscribe.push(subscr);
		 // Inicializar MSAL al construir el servicio
		 


	}
  async ngOnInit(): Promise<void> {
    await this.initializeMsal();
  }

	  // Configuración de Azure AD
	  private msalConfig: Configuration = {
		auth: {
			clientId: this.OauthService.config.appId,
			authority: this.OauthService.config.authority,
		  redirectUri: window.location.origin,
		},
		cache: {
		  cacheLocation: 'localStorage',
		  storeAuthStateInCookie: true
		}
	  };

	  
  // Scopes requeridos
  private loginRequest = {
    scopes: [
      "user.read"
    ]
  };

 private _tokenBroadcast$ = new BehaviorSubject<string | null>(null);
  tokenBroadcast$ = this._tokenBroadcast$.asObservable();

   notifyTokenUpdate(newToken: string) {
    this._tokenBroadcast$.next(newToken);
  }

	GetWidgets():Observable<ActionResult<MicroApplication[]>>{   
		return this.http
		  .get<ActionResult<MicroApplication[]>>(`${this.configService.config.apiMicroApplicationsSeven}/MicroApplications/GetWidgets`);
	  }

	

	GetWidgetsy(){   
	
		return this.authHttpService.GetWidgets().pipe(
			map((response: ActionResult<any>) => {
				if (!response.isSuccessful) {
					this.messagesService.error(response.errorMessage);
					const result = null;
					return result;
				}
				const result = null;
				return response;
			}),
			
			// switchMap(() => this.getUserByToken()),
			// catchError((err) => {
			// 	this.notificationsService.ErrorSweet(
			// 		'Error conectando con el servidor de seguridad'
			// 	);
			// 	return of(undefined);
			// }),
			finalize(() => this.isLoadingSubject.next(false))
		);
	}

// Inicializar MSAL
public async initializeMsal(): Promise<void> {
    try {
      this.msalInstance = new PublicClientApplication(this.msalConfig);
      await this.msalInstance.initialize();
      console.log('MSAL initialized successfully');
    } catch (error) {
      console.error('Error initializing MSAL:', error);
      throw error;
    }
  }

	// public methods
	login(user: string, password: string,valueatentication:string): Observable<UserModel> {
		this.isLoadingSubject.next(true);
		return this.authHttpService.login(user, password,valueatentication).pipe(
			map((response: ActionResult<AuthModel>) => {
				if (!response.isSuccessful) {
					this.messagesService.error(response.errorMessage);
					const result = null;
					return result;
				}
				else{
					if(response.errorMessage){
				
						localStorage.setItem('licensemessageerror', JSON.stringify(response.errorMessage));
						localStorage.setItem('licensehead', JSON.stringify(response.errorMessage));
						// this.messagesService.error(response.errorMessage);
					}
				}
			
				const result = this.setAuthFromLocalStorage(response.result);
				return result;
			}),
			
			switchMap(() => this.getUserByToken()),
			catchError((err) => {
				this.messagesService.error(
					'Error conectando con el servidor de seguridad'
				);
				return of(undefined);
			}),
			finalize(() => this.isLoadingSubject.next(false))
		);
	}

		// public methods
		loginAzureAD(user: string, password: string,valueatentication:string): Observable<UserModel> {
			this.isLoadingSubject.next(true);
			return this.authHttpService.login(user, password,valueatentication).pipe(
				map((response: ActionResult<AuthModel>) => {
					if (!response.isSuccessful) {
						this.messagesService.error(response.errorMessage);
						const result = null;
						return result;
					}
					const result = this.setAuthFromLocalStorage(response.result);
					return result;
				}),
				
				// switchMap(() => this.getUserByToken()),
				// catchError((err) => {
				// 	this.notificationsService.ErrorSweet(
				// 		'Error conectando con el servidor de seguridad'
				// 	);
				// 	return of(undefined);
				// }),
				finalize(() => this.isLoadingSubject.next(false))
			);
		}
	
	// public methods
	doubleauthentication(code: string,intentos:number,user:string):Observable<ActionResult<any>> {
		return this.authHttpService.doubleauthentication(code,intentos,user);
	}

	Getcapchat():Observable<ActionResult<any>> {
		return this.authHttpService.Getcapchat();
	}

	loadimgloggin():Observable<any> {
		return this.authHttpService.loadimgloggin();
	}
	
	Getdatainsta():Observable<ActionResult<any>> {
		return this.authHttpService.Getdatainsta();
	}
	generate(){
		return this.authHttpService.generate();
	}

	validate(cap:any){
		return this.authHttpService.validate(cap);
	}
	
	validatedMicroApp(code:string):Observable<ActionResult<any>> {
		return this.authHttpService.validatedMicroApp(code);
	}

	logout() {
		localStorage.removeItem(this.authLocalStorageToken);
		this.router.navigate(['/login'], {
			queryParams: {},
		});
	}

	async logoutSession() {
		// Limpieza básica de datos locales
		localStorage.removeItem(this.authLocalStorageToken);
		localStorage.removeItem('licensemessageerror');
		localStorage.removeItem('Pages');
		localStorage.removeItem('listHisotrial');
		
		const loginOption = localStorage.getItem('login_option');
		localStorage.removeItem('login_option');
	  
	
		if (loginOption === 'sso') {
		  this.stopRefreshTokenTimer();
		  window.location.href = this.configService.config.loginAgora;
		  return; 
		}
	  
		
		await this.configService.getAppConfig();
		await this.OauthService.getAppConfig();
	  

		this.clearSession();
	  
	
		localStorage.setItem('logout', JSON.stringify("S"));
	  

		this.router.navigate(['/login']).then(() => {
		  this.stopRefreshTokenTimer();
		  this.clearSession();
		
		});
	  }
	  

	  private clearSession(): void {
		try {
		  const keysToRemove = [
			this.authLocalStorageToken,
			'licensemessageerror',
			'login_option'
		  ];
	  
		  keysToRemove.forEach((key) => localStorage.removeItem(key));
	  
		  localStorage.setItem('logout', JSON.stringify('S'));
	  
		  // Limpia el timeout si está definido
		  if (this.refreshTokenTimeout) {
			clearTimeout(this.refreshTokenTimeout);
			this.refreshTokenTimeout = null; 
		  }
	  
	  
		} catch (error) {
		  console.error('Error al limpiar la sesión:', error);
		}
	  }
	  
	
	  async logoutSessiontimer() {
		localStorage.removeItem(this.authLocalStorageToken);
		localStorage.removeItem('licensemessageerror');
	  
		const loginOption = localStorage.getItem('login_option');
		localStorage.removeItem('login_option');
	  
		// 🔹 Caso SSO
		if (loginOption && loginOption === 'sso') {
		  this.stopRefreshTokenTimer();
		  window.location.href = this.configService.config.loginAgora;
		  return;
		}
	  
		// 🔹 Caso normal (no SSO)
		const loginPath = '/login';
		const routeExists = this.router.config.some(
		  route => route.path === loginPath.replace('/', '')
		);
	  
		const targetRoute = routeExists ? loginPath : '/'; // fallback a "/" o lo que definas
		this.router.navigate([targetRoute]).then(() => {
		  this.stopRefreshTokenTimer();
		});
	  
		this.messagesService
		  .tokenVencido(
			'Debes volver a iniciar sesión',
			'Has estado inactivo por varios minutos',
			'info'
		  )
		  .then((result) => {
			if (result.isConfirmed) {
			  window.location.reload();
			}
		  });
	  }
	  




	getUserByToken(): Observable<UserModel> {
		const auth = this.getAuthFromLocalStorage();
		const sessionData = JSON.parse(sessionStorage.getItem('sessionData') || '{}');
		
if(sessionData.selectedCompany){
	sessionData.selectedCompany.code;
		// if(sessionData.selectedCompany.code!=Codigo){
		// 	sessionData.selectedCompany.code=Codigo;
		// 	this._commonServices.setItemsessionStorage('sessionData', sessionData);
		// }
}

	

		if (!auth || !auth.accessToken) {
			return of(undefined);
		}

		this.isLoadingSubject.next(true);
		return this.authHttpService.getUserByToken(auth.accessToken).pipe(
		
			map((resp) => {
				const user: UserModel = resp.result;
				if (user) {
					this.currentUserValue = user;
					this.startRefreshTokenTimer();
				} else {
					this.messagesService.error(resp.errorMessage);
					setTimeout(() => {
						this.logoutSession();
						}, 1800);
				;
				}
				return user;
			}), 
			catchError((err) => {
				this.messagesService.error(
					'Error conectando con el servidor de seguridad'
				);
				setTimeout(() => {
					this.logoutSession();
					}, 1000);

			
				return of(undefined);
			}),
			finalize(() => this.isLoadingSubject.next(false))
		);
	}

	getUserToken(): AuthModel {
		const auth = this.getAuthFromLocalStorage();
		if (!auth || !auth.accessToken) {
			return undefined;
		}
		return auth;
	}

	// need create new user then login
	registration(user: UserModel): Observable<any> {
		this.isLoadingSubject.next(true);
		return this.authHttpService.createUser(user).pipe(
			map(() => {
				this.isLoadingSubject.next(false);
			}),
			switchMap(() => this.login(user.email, user.password,"")),
			catchError((err) => {
				console.error('err', err);
				return of(undefined);
			}),
			finalize(() => this.isLoadingSubject.next(false))
		);
	}

	forgotPassword(email: string): Observable<ActionResult<any>> {
		this.isLoadingSubject.next(true);
		return this.authHttpService.forgotPassword(email).pipe(
			catchError((err) =>
				of(			this.messagesService.error('Error al enviar correo'))
			),
			map((resp: ActionResult<any>) => {
				if (!resp.isSuccessful)
					this.messagesService.error(
						`Error al enviar correo: ${resp.errorMessage}`
					);
				return resp;
			}),
			finalize(() => this.isLoadingSubject.next(false))
		);
	}

	// private methods
	setAuthFromLocalStorage(auth: AuthModel): boolean {
		// Almacena el token de acceso en el local storage para mantener al usuario logueado mientras navega por las páginas
		//console.log('auth1', auth);
		if (auth && auth.accessToken) {
			localStorage.setItem(
				this.authLocalStorageToken,
				JSON.stringify(auth)
			);
             this.notifyTokenUpdate(auth.accessToken);

			return true;
		}
		return false;
	}

	getAuthFromLocalStorage(): AuthModel {
		try {
			const authData = JSON.parse(
				localStorage.getItem(this.authLocalStorageToken)
			);
	
			return authData;
		} catch (error) {
			console.error(error);
			return undefined;
		}
	}

	ngOnDestroy() {
		this.unsubscribe.forEach((sb) => sb.unsubscribe());
	}

	resetPassword(resetPass: resetpassword): Observable<ActionResult<any>> {
		this.isLoadingSubject.next(true);
		return this.authHttpService.resetPassword(resetPass).pipe(
			catchError((err) =>
				of(
					this.messagesService.error(
						'Error al Cambiar la contraseña'
					)
				)
			),
			map((resp: ActionResult<any>) => {
				if (!resp.isSuccessful)
					this.messagesService.error(
						`Error al Cambiar la contraseña: ${resp.errorMessage}`
					);
				return resp;
			}),
			finalize(() => this.isLoadingSubject.next(false))
		);
	}

	getUserPhotoProfile(user: string) {
		return this.authHttpService.getUserProfiles(user).pipe(
			map((resp) => {
				if (!resp.isSuccessful)
					this.messagesService.error(
						`Error cargando foto de usuario : ${resp.messages}`
					);
				return resp.result;
			})
		);
	}
	
	getUserPhotoProfiles(user: string): Observable<any> {
		
		this.isLoadingSubject.next(true);
		return this.authHttpService.getUserProfiles(user).pipe(
		  catchError(err => of(this.messagesService.error(`Error cargando foto de usuario`))),
		  map((resp: ActionResult<any>) => {     
			return resp.result;
		  }),
		  finalize(() => this.isLoadingSubject.next(false))
		);
	  }

	
	getUserPhotologoProfile(emp_codi: string) {
		return this.authHttpService.getUserlogo(emp_codi).pipe(
			map((resp) => {
				if (!resp.isSuccessful)
					this.messagesService.error(
						`Error cargando foto de usuario : ${resp.messages}`
					);
				return resp.result;
			})
		);
	}
	getUserPhotologodefaul() {
		return this.authHttpService.getUserlogodefaul().pipe(
			map((resp) => {
				if (!resp.isSuccessful)
					this.messagesService.error(
						`Error cargando foto de Empresa : ${resp.errorMessage}`
					);
				return resp.result;
			})
		);
	}

	// refreshToken(){

	//   this.authHttpService.refreshToken().pipe(map((user) => {
	//     this.setAuthFromLocalStorage
	//     this.startRefreshTokenTimer();
	//     return user;
	// }));
	// }

	refreshToken() {
		
		return this.authHttpService.refreshToken().pipe(
			map((user) => {
				this.setAuthFromLocalStorage(user);
				this.startRefreshTokenTimer();
				return user;
			})
		);
	}

	changeTokenCompany(companyCode: number) {
		return this.authHttpService.refreshCompanyToken(companyCode).pipe(
			map((user) => {
				this.setAuthFromLocalStorage(user);
				this.startRefreshTokenTimer();
				return user;
			})
		);
	}
    private refreshTokenTimeout;
	private startRefreshTokenTimer() {
		const jwtToken = JSON.parse(
			atob(this.getAuthFromLocalStorage().accessToken.split('.')[1])
		);

		// seteo el timeOut para hacer el refresh dos minuto antes de que el token expire
		const expires = new Date(jwtToken.exp * 1000);
		const timeout = expires.getTime() - Date.now() - 60 * 2000;
		this.refreshTokenTimeout = setTimeout(
			() => this.refreshToken().subscribe(),
			timeout
		);
	}

	private stopRefreshTokenTimer() {
		clearTimeout(this.refreshTokenTimeout);
	}

	
	validateSsoToken(token: string,code:string) {
		return this.authHttpService.validateSsoToken(token,code).pipe(
			map((response: ActionResult<AuthModel>) => {
				if (!response.isSuccessful) {
					this.messagesService.error(response.errorMessage);
				}
				return this.setAuthFromLocalStorage(response.result);
			}),
			 switchMap(() => this.getUserByToken()),
			catchError((err) => {
				console.error('err', err);
				this.messagesService.error(err);
				setTimeout(() => {
					this.router.navigateByUrl('/error/404');
					}, 1100);
		
				return of(undefined);
			}),
		
			finalize(() => this.isLoadingSubject.next(false))
		);
	}
	updatecompany(companycode:Company){
		this.currentUserValue.selectedCompany.code=companycode[0].code
		this.currentUserValue.selectedCompany.name=companycode[0].name

		return true;
	}

	  // Sign out
	  async signOut(): Promise<void> {
		// await this.msalService.logout().toPromise();
		this.user = undefined;
		this.graphClient = undefined;
		this.authenticated = false;
	  }
	  async valsession(): Promise<void> {
  
		if (!this.graphClient) {
		  return undefined;
		}
	  
	  }


	


	  async signInOu(): Promise<number> {
		try {
		  await this.msalInstance.handleRedirectPromise();
	  
		  if (!this.msalInstance) {
			await this.initializeMsal();
		  }
	  
		  let account = this.msalInstance.getActiveAccount();
	  
		  if (!account) {
			const result = await this.msalInstance.loginPopup(this.loginRequest);
			if (result) {
			  this.msalInstance.setActiveAccount(result.account);
			  account = result.account;
			} else {
			  return 0; // No login result
			}
		  }
	  
		  if (account) {
			this.authenticated = true;
			this.user = await this.getUsers();
			return 1;
		  }
	  
		  return 0;
	  
		} catch (error: any) {
		  let errorMessage = 'Login failed';
		  console.error('Azure AD Login Raw Error:', error);
	  
		  if (error.errorCode) {
			switch (error.errorCode) {
			  case 'user_cancelled':
				errorMessage = 'Login was cancelled by the user';
				break;
			  case 'popup_blocked':
				errorMessage = 'Popup was blocked by the browser';
				break;
			  case 'interaction_required':
				errorMessage = 'User needs to interact again (e.g., expired session)';
				break;
			  case 'login_required':
				errorMessage = 'Login required: no active session';
				break;
			  default:
				errorMessage = `MSAL Error: ${error.errorCode} - ${error.errorMessage || error.message}`;
			}
		  } else if (error.message) {
			errorMessage = `General Error: ${error.message}`;
		  }
	  
		  console.error('Azure AD Login Error:', errorMessage);
		  return 3;
		}
	  }
	  




  
  // Método para verificar si el token está activo
  isTokenActive(): boolean {
	const userData = localStorage.getItem('userData');
	if (userData) {
	  const { expiresOn } = JSON.parse(userData);
	  return new Date(expiresOn) > new Date();
	}
	return false;
  }
  
  // Método de logout
  async logoutA(): Promise<void> {
	try {
	  await this.msalInstance.logoutPopup();
	  localStorage.removeItem('userData');
	//   this.router.navigate(['/login']);
	} catch (error) {
	  this.messagesService.error('Logout failed');
	  console.error('Logout Error:', error);
	}
  }

  private async getUsers(): Promise<User | undefined> {
	if (!this.authenticated) return undefined;
  
	const authProvider = new AuthCodeMSALBrowserAuthenticationProvider(
	  this.msalInstance as PublicClientApplication,
	  {
		account: this.msalInstance.getActiveAccount()!,
		scopes: this.OauthService.config.scopes,
		interactionType: InteractionType.Popup
	  }
	);
  
	this.graphClient = Client.initWithMiddleware({
	  authProvider: authProvider
	});
  
	const graphUser: MicrosoftGraph.User = await this.graphClient
	  .api('/me')
	  .select('displayName,mail,userPrincipalName')
	  .get();
  
	const user = new User();
	user.displayName = graphUser.displayName ?? '';
	user.email = graphUser.mail ?? graphUser.userPrincipalName ?? '';
	user.timeZone = 'UTC'; // O asigna desde otro lugar si es necesario
	user.avatar = '/assets/no-profile-photo.png';
  
	return user;
  }
  
	// private setLoggedIn() {
    //     this.loggedIn = this.msalService.instance.getAllAccounts().length > 0;
    //   }
	// updateLoggedInStatus() {
    //     this.msalBroadcastService.inProgress$
    //       .pipe(
    //         filter((status: InteractionStatus) => status === InteractionStatus.None),
    //         takeUntil(this._destroying$)
    //       )
    //       .subscribe(() => {
    //         this.setLoggedIn();
    //         this.checkAndSetActiveAccount();
    //       });
    //   }

    //   loginAzure() {
	// 	this.msalService.initialize();
    //     if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
    //       this.loginWithPopup();
    //     } else {
    //       this.loginWithRedirect();
    //     }

	validarToken(token: TokenRequest) {
		return this.authHttpService.validarToken(token);
	  }
	  

	  generateQRCode(identifier :string){
		return this.authHttpService.generateQRCode(identifier);
	}

	validate2fa(code:string , secretkey:string){
		return this.authHttpService.validate2fa(code,secretkey);
	}


      }
	


	

